// extracted by mini-css-extract-plugin
module.exports = {"dragDropContainer":"DragAndDropUploadFiles_dragDropContainer__wuFBU","active":"DragAndDropUploadFiles_active__1z4ze","dragElement":"DragAndDropUploadFiles_dragElement__PhVTm"};